import React, { useEffect, useState, useContext, useRef } from "react";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "antd/dist/antd.min.css";
import { Modal } from "react-bootstrap";
import { DataGrid } from "@material-ui/data-grid";
import { makeStyles } from "@material-ui/core/styles";
import { Box, withStyles, CircularProgress } from "@material-ui/core";
import { Row, Col, Button } from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";
import toast from "react-hot-toast";
import Select from "react-select";
import { DatePicker } from "antd";

//Global State import
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";

//Context import
import AuthContext from "../../../components/shared/Context";
import ExcelDownloader from "./ExcelDownloader";
import TotalDoseConsumptionChart from "../TCInventory/List/TotalDoseConsumptionChart";
import PerPatientDatewiseChart from "../TCInventory/List/PerPatientDatewiseChart";
import PerPatientDoseChart from "../TCInventory/List/PerPatientDoseChart";
import PatientVisitFrequencyChart from "../TCInventory/List/PatientVisitFrequencyChart";
import TotalDoseConsumptionDistrictWise from "../TCInventory/List/TotalDoseConsumptionDistrictWise";

import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

const { RangePicker } = DatePicker;

const ListPatientDosingHistoryChild = () => {
  let navigate = useNavigate();
  const { loggedInUserDetails } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [unfilteredData, setUnfilteredData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});
  const [selectedReport, setSelectedReport] = useState();
  const [openReportModal, setOpenReportModal] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [deliveryInfo, setDeliveryInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedAgeFilter, setSelectedAgeFilter] = useState(null);
  const [selectedProductFilter, setSelectedProductFilter] = useState(null);
  const [selectedDistrictFilter, setSelectedDistrictFilter] = useState(null);
  const [selectedDiagnosisFilter, setSelectedDiagnosisFilter] = useState(null);
  const [productFilterOptions, setProductFilterOptions] = useState([]);
  const [districtFilterOptions, setDistrictFilterOptions] = useState([]);
  const [diagnosisFilterOptions, setDiagnosisFilterOptions] = useState([]);
  const searchRef = useRef();
  //Error Logging Service
  const [{ errorLogApi, dateFormatter, expiryFormatter }] = useAtom(gbState);

  const reportOptions = [
    { value: 1, label: "Total Dose Consumption" },
    { value: 2, label: "Per Patient Dose Chart" },
    { value: 3, label: "Per Patient Datewise Chart" },
    { value: 4, label: "Patient Visit Frequency Chart" },
    { value: 5, label: "Total Dose Consumption District Wise" },
  ];

  const ageFilterOptions = [
    { value: "0-18", label: "0-18 years" },
    { value: "18+", label: "18+ years" },
  ];

  const getDataFromServer = () => {
    setLoading(true);
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    };
    let urlLink = `${process.env.REACT_APP_API_URL}/tcstocksale/history/ad`;

    axios
      .get(urlLink, config)
      .then((res) => {
        const oldData = res.data.dose_history;
        //console.log(oldData);
        const updatedData = oldData.map((data) => {
          //   console.log(data.purchase_inventory.product_id.products);
          return {
            ...data,
            id: data?._id,
            dose_id: data?.s_register?.tc_sale_id,
            date: data?.s_register?.date_time_of_infusion,
            patient_name: data?.s_register?.patient_id?.patient_name,
            patient_id: data?.s_register?.patient_id?.patientId,
            patient_record: data?.s_register?.patient_id,
            visit_date: data?.s_register?.visit_id?.date_of_visit,
            visit_record: {
              ...data?.s_register?.visit_id,
              id: data?.s_register?.visit_id?._id,
            },
            quantity:
              data?.s_register?.quantity +
              " " +
              data?.s_register?.product_id?.products?.storage_unit,
            product_name: data?.s_register?.product_id?.products?.product_name,
            product_code: data?.s_register?.product_id?.products?.item_code,
            tc_name: data?.s_register?.tc_id?.tcenters?.name_tc,
            hcp_name: data?.s_register?.given_by_nurse_or_doctor,
            state: data?.s_register?.tc_id?.tcenters?.state,
            district: data?.s_register?.tc_id?.tcenters?.district,
          };
        });
        //console.log(updatedData);
        setData(updatedData);
        setUnfilteredData(updatedData);

        // Generate product filter options from the data
        const uniqueProducts = [
          ...new Set(updatedData.map((item) => item.product_name)),
        ].filter(Boolean);
        const productOptions = uniqueProducts.map((product) => ({
          value: product,
          label: product,
        }));
        setProductFilterOptions(productOptions);

        // Generate district filter options from the data
        const uniqueDistricts = [
          ...new Set(updatedData.map((item) => item?.district)),
        ].filter(Boolean);
        const districtOptions = uniqueDistricts.map((district) => ({
          value: district,
          label: district,
        }));
        setDistrictFilterOptions(districtOptions);

        // Generate diagnosis filter options from the data
        const uniqueDiagnoses = [
          ...new Set(
            updatedData.map(
              (item) => item?.patient_record?.diagnoses?.diagnosis_name
            )
          ),
        ].filter(Boolean);
        const diagnosisOptions = uniqueDiagnoses.map((diagnosis) => ({
          value: diagnosis,
          label: diagnosis,
        }));
        setDiagnosisFilterOptions(diagnosisOptions);

        setLoading(false);
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getDataFromServer();
  }, []);

  const useStyles = makeStyles(() => ({
    multiLineCell: {
      display: "flex",
      wordBreak: "keep-all",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      lineHeight: "1.2rem",
      height: "100%",
    },
    customRow: {
      height: "75px", // Increase the row height as needed
    },
  }));

  const MultiLineCellRenderer = (params) => {
    const classes = useStyles();
    return (
      <div className={classes.multiLineCell}>
        <span id="content1">{params?.row?.product_name}</span>
        <span id="content2">
          <small className="small-font-size">{params?.row?.product_code}</small>
        </span>
      </div>
    );
  };

  const PatientLineCellRenderer = (params) => {
    const classes = useStyles();
    return (
      <div className={classes.multiLineCell}>
        <span id="content1">
          <b>{params?.row?.patient_name?.toUpperCase()}</b>
        </span>
        <span id="content2">
          <small className="small-font-size">
            <b>Patient ID:</b> {params?.row?.patient_id}
          </small>
        </span>
      </div>
    );
  };

  const columns = [
    {
      field: "Action",
      headerName: "Action",
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      width: 80,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="editiConContainer">
            {/* <Tooltip title="Product Information">
                <a
                  onClick={() => {
                    setDeliveryInfo(false);
                    viewRecord(params.row);
                  }}
                >
                  <i
                    className="mdi mdi-eye-circle-outline"
                    style={{ fontSize: "15px", color: "black" }}
                  ></i>
                </a>
              </Tooltip> */}
            <Tooltip title="Dose Information">
              <div
              // onClick={() =>
              //   navigate("/view-dose", {
              //     state: {
              //       visit: params.row.visit_record,
              //       patient: params.row.patient_record,
              //     },
              //   })
              // }
              >
                <i
                  className="mdi mdi-checkbox-marked-circle"
                  style={{
                    fontSize: "15px",
                    color: `${
                      params.row.allotment_recieved_status ? "blue" : "green"
                    }`,
                    cursor: "pointer",
                  }}
                ></i>
              </div>
            </Tooltip>
          </div>
        );
      },
    },

    {
      field: "patient_name",
      headerName: "Patient",
      width: 220,
      renderCell: PatientLineCellRenderer,
    },
    {
      field: "visit_date",
      headerName: "Dose Date",
      filterable: false,
      disableColumnMenu: true,
      width: 140,
      align: "center",
      renderCell: (params) => dateFormatter(params.row.visit_date),
    },
    {
      field: "dose_id",
      headerName: "Dose ID",
      filterable: false,
      disableColumnMenu: true,
      width: 160,
      align: "center",
    },
    {
      field: "product_name",
      headerName: "Product",
      width: 200,
      renderCell: MultiLineCellRenderer,
    },

    // {
    //   field: "patient_id",
    //   headerName: "Patient ID",
    //   width: 150,
    // },
    {
      field: "quantity",
      headerName: "Dose Qty",
      filterable: false,
      disableColumnMenu: true,
      width: 140,
      align: "center",
      renderCell: (params) => <div>{params?.row?.quantity}</div>,
    },
    {
      field: "hcp_name",
      headerName: "HCP",
      width: 130,
      filterable: false,
      disableColumnMenu: true,
      // align: "center",
      renderCell: (params) => <div>{params?.row?.hcp_name}</div>,
    },
    {
      field: "tc_name",
      headerName: "TC Name",
      width: 160,
      align: "center",
      renderCell: (params) => <div>{params?.row?.tc_name}</div>,
    },
    {
      field: "state",
      headerName: "State",
      filterable: false,
      disableColumnMenu: true,
      width: 110,
      renderCell: (params) => <div>{params?.row?.state}</div>,
    },
  ];

  const viewRecord = (rec) => {
    setCurrentRecord(rec);
    setOpenModal(true);
  };
  //   console.log(data);

  // let unfilterData = data;
  const handleSearch = (e) => {
    const searchValue = e;
    applyFilters(
      searchValue,
      selectedAgeFilter,
      selectedProductFilter,
      selectedDistrictFilter,
      selectedDiagnosisFilter
    );
  };

  const clearSearch = () => {
    searchRef.current.value = null;
    setSelectedAgeFilter(null);
    setSelectedProductFilter(null);
    setSelectedDistrictFilter(null);
    setSelectedDiagnosisFilter(null);
    setData(unfilteredData);
  };

  const calculateAge = (dateOfBirth) => {
    if (!dateOfBirth) return null;
    const birthDate = new Date(dateOfBirth);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  const applyFilters = (
    searchValue,
    ageFilter,
    productFilter,
    districtFilter,
    diagnosisFilter
  ) => {
    let filteredData = unfilteredData;

    // Apply search filter
    if (searchValue) {
      filteredData = filteredData.filter((item) => {
        return (
          item?.dose_id?.toLowerCase().includes(searchValue?.toLowerCase()) ||
          item?.patient_name
            ?.toLowerCase()
            .includes(searchValue?.toLowerCase()) ||
          item?.product_code
            ?.toLowerCase()
            .includes(searchValue?.toLowerCase()) ||
          item?.product_name
            ?.toLowerCase()
            .includes(searchValue?.toLowerCase()) ||
          item?.patient_id
            ?.toLowerCase()
            .includes(searchValue?.toLowerCase()) ||
          item?.sale_code?.toLowerCase().includes(searchValue?.toLowerCase()) ||
          item?.tc_name?.toLowerCase().includes(searchValue?.toLowerCase()) ||
          item?.state?.toLowerCase().includes(searchValue?.toLowerCase())
        );
      });
    }

    // Apply age filter
    if (ageFilter) {
      filteredData = filteredData.filter((item) => {
        const age = calculateAge(item?.patient_record?.date_of_birth);
        if (age === null) return false;

        if (ageFilter === "0-18") {
          return age >= 0 && age <= 18;
        } else if (ageFilter === "18+") {
          return age > 18;
        }
        return true;
      });
    }

    // Apply product filter
    if (productFilter) {
      filteredData = filteredData.filter((item) => {
        return item?.product_name === productFilter;
      });
    }

    // Apply district filter
    if (districtFilter) {
      filteredData = filteredData.filter((item) => {
        return item?.district === districtFilter;
      });
    }

    // Apply diagnosis filter
    if (diagnosisFilter) {
      filteredData = filteredData.filter((item) => {
        return (
          item?.patient_record?.diagnoses?.diagnosis_name === diagnosisFilter
        );
      });
    }

    setData(filteredData);
  };

  const handleDistrictFilterChange = (selected) => {
    setSelectedDistrictFilter(selected ? selected.value : null);
    const searchValue = searchRef.current ? searchRef.current.value : "";
    applyFilters(
      searchValue,
      selectedAgeFilter,
      selectedProductFilter,
      selected ? selected.value : null,
      selectedDiagnosisFilter
    );
  };

  const handleProductFilterChange = (selected) => {
    setSelectedProductFilter(selected ? selected.value : null);
    const searchValue = searchRef.current ? searchRef.current.value : "";
    applyFilters(
      searchValue,
      selectedAgeFilter,
      selected ? selected.value : null,
      selectedDistrictFilter,
      selectedDiagnosisFilter
    );
  };

  const handleDateChange = (dates, dateStrings) => {
    if (dates) {
      const [start, end] = dates;
      let filteredData = unfilteredData.filter((item) => {
        const visitDate = new Date(item.visit_date);
        return visitDate >= start && visitDate <= end;
      });
      // Apply other filters on top of date filter
      const searchValue = searchRef.current ? searchRef.current.value : "";
      if (
        searchValue ||
        selectedAgeFilter ||
        selectedProductFilter ||
        selectedDistrictFilter ||
        selectedDiagnosisFilter
      ) {
        filteredData = filteredData.filter((item) => {
          let matchesSearch = true;
          let matchesAge = true;
          let matchesProduct = true;
          let matchesDistrict = true;
          let matchesDiagnosis = true;
          // Apply search filter
          if (searchValue) {
            matchesSearch =
              item?.dose_id
                ?.toLowerCase()
                .includes(searchValue?.toLowerCase()) ||
              item?.patient_name
                ?.toLowerCase()
                .includes(searchValue?.toLowerCase()) ||
              item?.product_code
                ?.toLowerCase()
                .includes(searchValue?.toLowerCase()) ||
              item?.product_name
                ?.toLowerCase()
                .includes(searchValue?.toLowerCase()) ||
              item?.patient_id
                ?.toLowerCase()
                .includes(searchValue?.toLowerCase()) ||
              item?.sale_code
                ?.toLowerCase()
                .includes(searchValue?.toLowerCase()) ||
              item?.tc_name
                ?.toLowerCase()
                .includes(searchValue?.toLowerCase()) ||
              item?.state?.toLowerCase().includes(searchValue?.toLowerCase());
          }
          // Apply age filter
          if (selectedAgeFilter) {
            const age = calculateAge(item?.patient_record?.date_of_birth);
            if (age === null) {
              matchesAge = false;
            } else if (selectedAgeFilter === "0-18") {
              matchesAge = age >= 0 && age <= 18;
            } else if (selectedAgeFilter === "18+") {
              matchesAge = age > 18;
            }
          }
          // Apply product filter
          if (selectedProductFilter) {
            matchesProduct = item?.product_name === selectedProductFilter;
          }
          // Apply district filter
          if (selectedDistrictFilter) {
            matchesDistrict = item?.district === selectedDistrictFilter;
          }
          // Apply diagnosis filter
          if (selectedDiagnosisFilter) {
            matchesDiagnosis =
              item?.patient_record?.diagnoses?.diagnosis_name ===
              selectedDiagnosisFilter;
          }
          return (
            matchesSearch &&
            matchesAge &&
            matchesProduct &&
            matchesDistrict &&
            matchesDiagnosis
          );
        });
      }
      setData(filteredData);
    } else {
      // Reset to unfiltered data and apply other filters
      const searchValue = searchRef.current ? searchRef.current.value : "";
      applyFilters(
        searchValue,
        selectedAgeFilter,
        selectedProductFilter,
        selectedDistrictFilter,
        selectedDiagnosisFilter
      );
    }
  };

  const handleAgeFilterChange = (selected) => {
    setSelectedAgeFilter(selected ? selected.value : null);
    const searchValue = searchRef.current ? searchRef.current.value : "";
    applyFilters(
      searchValue,
      selected ? selected.value : null,
      selectedProductFilter,
      selectedDistrictFilter,
      selectedDiagnosisFilter
    );
  };

  const handleDiagnosisFilterChange = (selected) => {
    setSelectedDiagnosisFilter(selected ? selected.value : null);
    const searchValue = searchRef.current ? searchRef.current.value : "";
    applyFilters(
      searchValue,
      selectedAgeFilter,
      selectedProductFilter,
      selectedDistrictFilter,
      selected ? selected.value : null
    );
  };

  // Function to calculate total quantities by storage unit
  const calculateTotalQuantities = (dataArray) => {
    const totals = {};
    const productBreakdown = {};

    dataArray.forEach((item) => {
      const quantityStr = item.quantity;
      if (quantityStr) {
        // Extract number and unit from quantity string (e.g., "2 vial(s)" -> {number: 2, unit: "vial(s)"})
        const match = quantityStr.match(/^(\d+(?:\.\d+)?)\s+(.+)$/);
        if (match) {
          const number = parseFloat(match[1]);
          const unit = match[2];
          const productName = item.product_name;

          // Total by unit
          if (!totals[unit]) {
            totals[unit] = 0;
          }
          totals[unit] += number;

          // Breakdown by product
          if (!productBreakdown[unit]) {
            productBreakdown[unit] = {};
          }
          if (!productBreakdown[unit][productName]) {
            productBreakdown[unit][productName] = 0;
          }
          productBreakdown[unit][productName] += number;
        }
      }
    });

    return { totals, productBreakdown };
  };

  // Calculate totals for current filtered data
  const { totals: totalQuantities, productBreakdown } =
    calculateTotalQuantities(data);

  //Bulk Delete function
  const handleSelectionChange = (selectionModel) => {
    console.log("Selection changed:", selectionModel);
    setSelectedIds(selectionModel);
  };

  const deleteMultipleRecords = () => {
    let inputCode = "";
    console.log("Current selectedIds:", selectedIds);
    if (!selectedIds?.length) return toast.error("Please select Record(s)");

    confirmAlert({
      title: "",
      message: "Are you sure to delete record(s) ?",
      childrenElement: () => (
        <div>
          {/* Use the key here */}
          <input
            type="text"
            placeholder="Type Code..."
            className="mt-2"
            onChange={(e) => (inputCode = e.target.value)} // Direct assignment
          />
        </div>
      ),
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteRecordInBulk(inputCode),
        },
        {
          label: "No",
          //onClick: () => alert('Click No')
        },
      ],
    });
  };

  const deleteRecordInBulk = (inputCode) => {
    if (!inputCode) return toast.error("Please enter a valid code!");

    let userToken = localStorage.getItem("token");
    const config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/tcstocksale/delete/bulk`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { ids: selectedIds, secret_code: inputCode },
    };
    if (selectedIds.length > 0) {
      axios(config)
        .then(function (response) {
          getDataFromServer();
          toast.success("Stock Deleted Successfully.");
        })
        .catch(function (error) {
          errorLogApi(error, "PWStockDeleteMany", "/delete/bulk");
          toast.error(JSON.stringify(error.response.data.message));
        });
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <span>
          <h3>List All TC Dosing History</h3>
        </span>
      </div>

      <div className="mb-3 align-items-right">
        <Row className="align-items-center justify-content-end">
          <Col xs="auto" className="ml-auto">
            <Select
              name="reports"
              onChange={(selected, dropdown) => {
                if (selected) {
                  setSelectedReport(selected.value);
                } else {
                  setSelectedReport(null);
                }
              }}
              options={reportOptions}
              placeholder="Select Report Type"
              className="w-100"
              styles={{
                container: (provided) => ({
                  ...provided,
                  width: "200px", // Adjust this width as needed
                }),
              }}
              isClearable
              isSearchable
              value={
                reportOptions.find(
                  (option) => option.value === selectedReport
                ) || null
              }
            />
          </Col>
          <Col xs="auto">
            <Button
              onClick={() => {
                if (selectedReport) {
                  setOpenReportModal(true);
                } else {
                  toast.error("Select Report Type");
                }
              }}
              variant="primary"
            >
              View Report
            </Button>
          </Col>
          <Col xs="auto">
            {/* refresh button */}
            <Button
              variant="primary"
              className="refresh-btn"
              onClick={getDataFromServer}
              disabled={loading}
            >
              <i className="mdi text-2xl mdi-refresh"></i>
            </Button>
          </Col>
          <Col xs="auto">
            <ExcelDownloader
              data={data}
              excludedFields={[
                "id",
                "_id",
                "product_stock",
                "__v",
                "s_register",
              ]}
              filename={`Dosing_history_${new Date()
                .toISOString()
                .replace(/[-:.]/g, "")}.xlsx`}
            />
            {loggedInUserDetails?.role === "ST_ADM_ACCESS" && (
              <button
                className="btn btn-danger ms-2"
                onClick={deleteMultipleRecords}
              >
                <i className="mdi mdi-delete me-1 "></i>
              </button>
            )}
          </Col>
        </Row>
      </div>
      {/* Filters Row */}
      <Row className="align-items-center mb-3">
        <Col xs="auto">
          <span>Date Filter :</span>
          <RangePicker onChange={handleDateChange} style={{ minWidth: 180 }} />
        </Col>
        <Col xs="auto">
          <span>Age Filter :</span>
          <Select
            name="ageFilter"
            onChange={handleAgeFilterChange}
            options={ageFilterOptions}
            placeholder="Select Age Range"
            className="ms-2"
            styles={{
              container: (provided) => ({
                ...provided,
                width: "180px",
                display: "inline-block",
              }),
            }}
            isClearable
            isSearchable={false}
            value={
              ageFilterOptions.find(
                (option) => option.value === selectedAgeFilter
              ) || null
            }
          />
        </Col>
        <Col xs="auto">
          <span>Product Filter :</span>
          <Select
            name="productFilter"
            onChange={handleProductFilterChange}
            options={productFilterOptions}
            placeholder="Select Product"
            className="ms-2"
            styles={{
              container: (provided) => ({
                ...provided,
                width: "220px",
                display: "inline-block",
              }),
            }}
            isClearable
            isSearchable
            value={
              productFilterOptions.find(
                (option) => option.value === selectedProductFilter
              ) || null
            }
          />
        </Col>
        <Col xs="auto">
          <span>District Filter :</span>
          <Select
            name="districtFilter"
            onChange={handleDistrictFilterChange}
            options={districtFilterOptions}
            placeholder="Select District"
            className="ms-2"
            styles={{
              container: (provided) => ({
                ...provided,
                width: "220px",
                display: "inline-block",
              }),
            }}
            isClearable
            isSearchable
            value={
              districtFilterOptions.find(
                (option) => option.value === selectedDistrictFilter
              ) || null
            }
          />
        </Col>
        <Col xs="auto">
          <span>Diagnosis Filter :</span>
          <Select
            name="diagnosisFilter"
            onChange={handleDiagnosisFilterChange}
            options={diagnosisFilterOptions}
            placeholder="Select Diagnosis"
            className="ms-2"
            styles={{
              container: (provided) => ({
                ...provided,
                width: "220px",
                display: "inline-block",
              }),
            }}
            isClearable
            isSearchable
            value={
              diagnosisFilterOptions.find(
                (option) => option.value === selectedDiagnosisFilter
              ) || null
            }
          />
        </Col>
      </Row>
      <div className="patientListSearch">
        <InputGroup className="mb-3">
          <InputGroup.Text id="basic-addon1">Filter</InputGroup.Text>
          <Form.Control
            placeholder="Product / TC Name / Code / Company ..."
            aria-label="Search"
            aria-describedby="basic-addon1"
            name="searchPatients"
            ref={searchRef}
            onChange={(e) => handleSearch(e.target.value)}
          />
          <InputGroup.Text>
            <i
              className="mdi mdi-delete-outline"
              onClick={clearSearch}
              style={{ cursor: "pointer" }}
            ></i>
          </InputGroup.Text>
        </InputGroup>
      </div>

      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <CircularProgress />
          <span className="ms-3">Loading data...</span>
        </div>
      ) : (
        <DataGrid
          rows={data}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          displayTitle="Current Stocks"
          checkboxSelection
          style={{ height: "80vh" }}
          onSelectionModelChange={handleSelectionChange}
          disableSelectionOnClick
          getRowHeight={() => 80}
        />
      )}

      {/* Total Quantities Summary */}
      {!loading && Object.keys(totalQuantities).length > 0 && (
        <div className="mt-4">
          <Row className="align-items-center">
            <Col>
              <h6 className="mb-2">Total Quantities Summary:</h6>
              <div className="d-flex flex-wrap gap-3 mb-3">
                {Object.entries(totalQuantities).map(([unit, total]) => (
                  <div
                    key={unit}
                    className="px-3 py-2 bg-light border rounded"
                    style={{ minWidth: "120px" }}
                  >
                    <div className="text-center">
                      <div className="fw-bold text-primary">
                        {total.toLocaleString()}
                      </div>
                      <div className="small text-muted">{unit}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Detailed Breakdown */}
              <div className="mt-3">
                <h6 className="mb-2">Detailed Breakdown:</h6>
                <div className="row">
                  {Object.entries(productBreakdown).map(([unit, products]) => (
                    <div key={unit} className="col-md-6 col-lg-4 mb-3">
                      <div className="card">
                        <div className="card-header py-2">
                          <h6 className="mb-0 text-primary">{unit}</h6>
                        </div>
                        <div className="card-body py-2">
                          {Object.entries(products).map(
                            ([product, quantity]) => (
                              <div
                                key={product}
                                className="d-flex justify-content-between align-items-center mb-1"
                              >
                                <span
                                  className="small text-truncate"
                                  style={{ maxWidth: "70%" }}
                                >
                                  {product}
                                </span>
                                <span className="badge bg-secondary">
                                  {quantity.toLocaleString()}
                                </span>
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      )}

      {/* Modal Popup */}
      <Modal show={openModal} centered>
        <Modal.Header closeButton onClick={() => setOpenModal(false)}>
          <Modal.Title>Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalContent currentRecord={currentRecord} />
        </Modal.Body>
        {/* <Modal.Footer>
              <Button variant="secondary" onClick={() => setOpenModal(false)}>
                Close
              </Button>
            </Modal.Footer> */}
      </Modal>

      <Modal
        show={openReportModal}
        size="lg"
        centered
        onHide={() => setOpenReportModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div
            className="report-container p-5"
            style={{ maxHeight: "70vh", overflowY: "auto" }}
          >
            {selectedReport === 1 && <TotalDoseConsumptionChart data={data} />}
            {selectedReport === 3 && <PerPatientDatewiseChart data={data} />}
            {selectedReport === 2 && <PerPatientDoseChart data={data} />}
            {selectedReport === 4 && <PatientVisitFrequencyChart data={data} />}
            {selectedReport === 5 && (
              <TotalDoseConsumptionDistrictWise data={data} />
            )}
          </div>
        </Modal.Body>
      </Modal>
      {/* {JSON.stringify(data[0])} */}
    </div>
  );
};

const ModalContent = ({ currentRecord }) => {
  return <div className="">{/* {JSON.stringify(currentRecord)} */}</div>;
};

export default ListPatientDosingHistoryChild;
